// Races that both AP and L.A. Vote report. `use` picks which feed the site
// shows for each one:
//   'ap'     AP's race: title, votes, calls and % of expected vote
//   'lavote' L.A. Vote's race
// To switch a race, change its `use`. Listed in the order embeds show them.
// If AP hasn't published a race set to 'ap' yet, L.A. Vote's is shown instead.

/**
 * @typedef {Object} SharedRace
 * @property {string} name - Just for reading this list
 * @property {string} ap - AP race id (STATE_URL)
 * @property {string} lavote - L.A. Vote race id
 * @property {'ap' | 'lavote'} use - Which one to show
 */

/** @type {SharedRace[]} */
export const SHARED_RACES = [
  {
    name: 'L.A. mayor',
    ap: 'CA-84303',
    lavote: 'los-angeles-city-general-municipal-election-mayor-4348',
    use: 'ap',
  },
  {
    name: 'L.A. city attorney',
    ap: 'CA-84499',
    lavote: 'los-angeles-city-general-municipal-election-city-attorney-4348',
    use: 'ap',
  },
  {
    name: 'L.A. City Council District 3',
    ap: 'CA-84459',
    lavote:
      'los-angeles-city-general-municipal-election-member-of-the-city-council-3rd-district-4348',
    use: 'ap',
  },
  {
    name: 'L.A. City Council District 9',
    ap: 'CA-84460',
    lavote:
      'los-angeles-city-general-municipal-election-member-of-the-city-council-9th-district-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure EE',
    ap: 'CA-85065',
    lavote: 'los-angeles-city-general-municipal-election-measure-ee-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure FD',
    ap: 'CA-85069',
    lavote: 'los-angeles-city-general-municipal-election-measure-fd-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure LA',
    ap: 'CA-85063',
    lavote: 'los-angeles-city-general-municipal-election-measure-la-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure PL',
    ap: 'CA-85064',
    lavote: 'los-angeles-city-general-municipal-election-measure-pl-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure PRK',
    ap: 'CA-85066',
    lavote: 'los-angeles-city-general-municipal-election-measure-prk-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure PRT',
    ap: 'CA-85067',
    lavote: 'los-angeles-city-general-municipal-election-measure-prt-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure SC',
    ap: 'CA-85068',
    lavote: 'los-angeles-city-general-municipal-election-measure-sc-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Measure TE',
    ap: 'CA-85062',
    lavote: 'los-angeles-city-general-municipal-election-measure-te-4348',
    use: 'ap',
  },
  {
    name: 'L.A. Sheriff',
    ap: 'CA-84304',
    lavote: 'sheriff-4348',
    use: 'ap',
  },
];

/**
 * Which race file to load for a race, following its `use` above. Pass the AP
 * id; races that aren't in SHARED_RACES come back as AP.
 *   createSingleRaceFeed(...sharedRaceFile('CA-84303'))
 * @param {string} apId - e.g. 'CA-84303'
 * @returns {[string, 'ap' | 'lavote']} [race id, source]
 */
export function sharedRaceFile(apId) {
  const shared = SHARED_RACES.find((race) => race.ap === apId);
  return shared?.use === 'lavote' ? [shared.lavote, 'lavote'] : [apId, 'ap'];
}
